(() => {
  function init(scope) {
    scope.querySelectorAll('[data-auth-password]').forEach(button => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', () => {
        const input = document.getElementById(button.getAttribute('aria-controls'));
        const visible = input.type === 'password';
        input.type = visible ? 'text' : 'password';
        button.setAttribute('aria-pressed', String(visible));
        button.setAttribute('aria-label', visible ? button.dataset.hideLabel : button.dataset.showLabel);
      });
    });
    scope.querySelectorAll('[data-auth-form]').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const login = form.querySelector('[data-auth-login]');
      const recovery = form.querySelector('[data-auth-recovery]');
      if (login && recovery) {
        function showRecovery(open, focus = false) {
          login.hidden = open; recovery.hidden = !open;
          if (focus) (open ? recovery : login).querySelector('input:not([type=hidden])')?.focus();
        }
        showRecovery(location.hash === '#recover' || !!form.querySelector('[data-auth-recovery-result]'));
        form.querySelector('[data-auth-recover]').addEventListener('click', event => {
          event.preventDefault(); history.replaceState({}, '', '#recover'); showRecovery(true, true);
        });
        form.querySelector('[data-auth-login-link]').addEventListener('click', event => {
          event.preventDefault(); history.replaceState({}, '', location.pathname + location.search); showRecovery(false, true);
        });
        window.addEventListener('hashchange', () => showRecovery(location.hash === '#recover', true));
      }
      form.querySelectorAll('form').forEach(nativeForm => {
        const confirmation = nativeForm.querySelector('[name="customer[password_confirmation]"]');
        if (confirmation) nativeForm.querySelectorAll('input[type=password]').forEach(input => input.addEventListener('input', () => confirmation.setCustomValidity('')));
      });
      form.addEventListener('submit', event => {
        // Shopify owns authentication, errors and CAPTCHA; use its native forms.
        const password = event.target.querySelector('[name="customer[password]"]');
        const confirmation = event.target.querySelector('[name="customer[password_confirmation]"]');
        if (confirmation && password.value !== confirmation.value) {
          event.preventDefault(); confirmation.setCustomValidity(confirmation.dataset.mismatch); confirmation.reportValidity();
        }
      });
    });
  }
  const boot = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
